<template>
    <form @submit.prevent="submit">
            <textarea class="form-control" rows="3" v-model="patient.lembrete" :placeholder="lembretePlaceholder"></textarea>
            <button type="submit" class="btn btn-primary btn-sm" style="margin-top: 5px;">Salvar lembrete</button>
    </form>
</template>

<script>
    export default {
        name: "lembrete-form-component",

        props: {
            patient: { Object, required: true },
        },

        data() {
            return {
                lembretePlaceholder: 'Lembrete...',
                optionsToast: { timeout: 6000, position: 'topCenter' }
            }
        },

        methods:{
            submit() {
                axios.post('/patient/lembrete',this.patient)
                    .then(response => {
                        if(response.data.type == 'success'){
                            this.$toast.success(response.data.message, response.data.title, this.optionsToast);
                        } else if(response.data.type == 'warning'){
                            this.$toast.warning(response.data.message, response.data.title, this.optionsToast);
                        } else {
                            this.$toast.info(response.data.message, response.data.title, this.optionsToast);
                        }
                    }).catch(error => {
                    if(error.response.status === 401 || error.response.status === 419){
                        this.$toast.warning('Sua sessão expirou. Por favor atualize a página.', 'AVISO', this.optionsToast);
                    } else {
                        this.$toast.error(error.response.data.message, 'Erro', this.optionsToast);
                    }
                    console.log(error.response);
                });
            }
        }
    }
</script>
